import { useMemo, useState } from "react";
import "@/App.css";
import { MODES, buildCustomMode } from "./game/config";
import { CATEGORIES } from "./game/categories";
import { ModeSelect } from "./components/game/ModeSelect";
import GameScreen from "./components/game/GameScreen";
import { useAudioSynth } from "./hooks/useAudioSynth";

const CUSTOM_KEY = "number_memory_custom_cfg";
const CATEGORY_KEY = "number_memory_category";
const defaultCustom = { numbers: MODES.custom.numbers, bombs: MODES.custom.bombs, lives: MODES.custom.lives, memorize: MODES.custom.memorize };

function App() {
  const [selected, setSelected] = useState("easy");
  const [playing, setPlaying] = useState(false);
  const [timerOn, setTimerOn] = useState(MODES.easy.timerDefault);
  const [gameKey, setGameKey] = useState(0);
  const [muted, setMuted] = useState(() => localStorage.getItem("number_memory_muted") === "1");
  const [customCfg, setCustomCfg] = useState(() => JSON.parse(localStorage.getItem(CUSTOM_KEY) || "null") || defaultCustom);
  const [category, setCategory] = useState(() => (CATEGORIES[localStorage.getItem(CATEGORY_KEY)] ? localStorage.getItem(CATEGORY_KEY) : "numbers"));

  const changeCategory = (id) => {
    localStorage.setItem(CATEGORY_KEY, id);
    setCategory(id);
  };
  const modes = useMemo(() => ({ ...MODES, custom: buildCustomMode(customCfg) }), [customCfg]);
  const play = useAudioSynth(muted);

  const updateCustom = (cfg) => {
    localStorage.setItem(CUSTOM_KEY, JSON.stringify(cfg));
    setCustomCfg(cfg);
  };

  const toggleMute = () => {
    localStorage.setItem("number_memory_muted", muted ? "0" : "1");
    setMuted(!muted);
  };

  return (
    <div className="app-bg min-h-screen font-body text-white">
      {playing ? (
        <GameScreen key={gameKey} mode={modes[selected]} category={CATEGORIES[category]} timerOn={timerOn} play={play} muted={muted} onMute={toggleMute} onExit={() => setPlaying(false)} />
      ) : (
        <ModeSelect modes={modes} category={category} onCategoryChange={changeCategory} customCfg={customCfg} onCustomChange={updateCustom} selected={selected} onSelect={(id) => { if (id !== selected) setTimerOn(MODES[id].timerDefault); setSelected(id); play("flip"); }} timerOn={timerOn} onTimerToggle={setTimerOn} onStart={() => { setGameKey((k) => k + 1); setPlaying(true); }} muted={muted} onMute={toggleMute} />
      )}
    </div>
  );
}

export default App;
